import { AddOnOrderProps } from './AddOnOrder';

const ContactInfoOrder = ({ orderData, setOrderData }: AddOnOrderProps) => {
  const handleData = (e: React.ChangeEvent<HTMLInputElement>) => {
    setOrderData({
      ...orderData,
      [e.target.name]: e.target.value,
    });
  };

  return (
    <div className="px-4 pt-6 pb-[150px] lg:mt-10 lg:w-[95%] lg:self-start lg:rounded-2xl lg:p-8 lg:shadow-order">
      <p className="hidden text-xl font-semibold text-primary-black lg:block">
        Contact Info
      </p>

      <div className="my-6 hidden w-full border border-b border-[#E4EBF5] lg:block" />

      <p className="text-base font-semibold text-primary-black">
        You’re almost done, let’s get your details so we can reach you.
      </p>

      <div className="mt-6">
        <p className="text-xs font-semibold text-primary-black lg:text-base">
          Your Name<span className="text-primary-red">*</span>
        </p>
        <input
          className="mt-2 w-full rounded-lg border border-[#CFD8E2] px-3 py-[14px] text-sm outline-none"
          placeholder="e.g John Doe"
          type="text"
          name="name"
          onChange={handleData}
          value={orderData.name}
        />
      </div>

      <div className="mt-4">
        <p className="text-xs font-semibold text-primary-black lg:text-base">
          Your Email<span className="text-primary-red">*</span>
        </p>
        <input
          className="mt-2 w-full rounded-lg border border-[#CFD8E2] px-3 py-[14px] text-sm outline-none"
          placeholder="e.g johndoe@email.com"
          type="email"
          name="email"
          onChange={handleData}
          value={orderData.email}
        />
      </div>

      <div className="mt-6">
        <p className="text-xs font-semibold text-primary-black lg:text-base">
          Your Phone or WhatsApp Number
          <span className="text-primary-red">*</span>
        </p>
        <input
          className="mt-2 w-full rounded-lg border border-[#CFD8E2] px-3 py-[14px] text-sm outline-none"
          placeholder="e.g 081234567890"
          type="number"
          name="phone"
          onChange={handleData}
          value={orderData.phone}
        />
      </div>
    </div>
  );
};

export default ContactInfoOrder;
